function normalizeValue(value) {
  return String(value || '').trim().toLowerCase();
}

export function getCaseStatusBadgeStatus(status) {
  const normalizedStatus = normalizeValue(status);
  if (normalizedStatus === 'new') {
    return 'success';
  }
  if (normalizedStatus === 'closed') {
    return 'danger';
  }
  return '';
}

export function getCasePriorityBadgeStatus(priority) {
  const normalizedPriority = normalizeValue(priority);
  if (normalizedPriority === 'low') {
    return 'success';
  }
  if (normalizedPriority === 'medium') {
    return 'warning';
  }
  if (normalizedPriority === 'high') {
    return 'danger';
  }
  return '';
}

export function getCaseTypeLabel(caseItem) {
  const fields = caseItem?.fields || {};
  const requestCategory = normalizeValue(fields.request_category);
  const serviceCaseType = normalizeValue(fields.service_case_type);
  const tradingCaseType = normalizeValue(fields.trading_case_type);
  const labelByValue = {
    new_account: 'New Account',
    close_account: 'Close Account',
    service_other: 'Service / Other',
    service_maintenance: 'Service / Other',
    trading_related: 'Trading Related',
    orion_request: 'Orion Request',
    client_record_changes: 'Client Record / Account Changes',
    questions: 'Questions',
    business_development: 'Business Development',
    advisor_org_maintenance: 'Advisor Org Maintenance',
    compliance: 'Compliance',
    paperwork_request: 'Paperwork Request',
    raise_cash_distribute: 'Get Cash (Distribute Cash)',
    get_cash: 'Get Cash (Distribute Cash)',
    add_cash: 'Add Cash (Deposit Cash)',
    trade_request_instructions: 'Trade Request / Instructions',
    trade_review: 'Trade Review',
    advocacy: 'Advocacy',
    ips_request: 'IPS Request',
    reoptimization: 'Reoptimization',
    vadis_question: 'Vadis Question',
  };

  return labelByValue[serviceCaseType] ||
    labelByValue[tradingCaseType] ||
    labelByValue[requestCategory] ||
    caseItem?.type ||
    'Case';
}
